/**
 * @generated SignedSource<<a5d4ee65f4e41fad68117b2e23dc414f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TrackAiActivityInput = {
  entityId: string;
  kind: string;
  organizationId: string;
  productId?: string | null;
};
export type useTrackAIActivityMutation$variables = {
  input: TrackAiActivityInput;
};
export type useTrackAIActivityMutation$data = {
  readonly trackAiActivity: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type useTrackAIActivityMutation = {
  response: useTrackAIActivityMutation$data;
  variables: useTrackAIActivityMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TrackAiActivityResponse",
    "kind": "LinkedField",
    "name": "trackAiActivity",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTrackAIActivityMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTrackAIActivityMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d64f2fb60d04fe34d0471e30134d7296",
    "id": null,
    "metadata": {},
    "name": "useTrackAIActivityMutation",
    "operationKind": "mutation",
    "text": "mutation useTrackAIActivityMutation(\n  $input: TrackAiActivityInput!\n) {\n  trackAiActivity(input: $input) {\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "135849fb1c0332002ed0631c6be665eb";

export default node;
